import React from 'react';
import { HashRouter, Redirect, Switch } from 'react-router-dom';
import { AppLayoutContainer } from './modules/Layout/shared/AppLayoutContainer';
import { DocsRoutes } from './modules/Docs/router/Routes';
import { ServerRoutes } from './modules/Servers/router/Routes';

const AppRouter = () => (
  <HashRouter>
    <AppLayoutContainer>
      <Switch>
        {DocsRoutes}
        {ServerRoutes}
        <Redirect to="/docs" />
      </Switch>
    </AppLayoutContainer>
  </HashRouter>
);

export { AppRouter };
